import { useAppConfig } from "./useAppConfig";

export const formatCurrency = (
  amount,
  {
    currencyPrecision = 2,
    currencySymbol = "",
    currencySymbolPlacement = "prefix",
    showCurrency,
  } = {},
) => {
  const numericAmount =
    amount === null || amount === undefined ? 0 : Number(amount);
  const safeAmount = Number.isFinite(numericAmount) ? numericAmount : 0;
  const precision = Number.isInteger(currencyPrecision)
    ? currencyPrecision
    : 2;
  const formattedAmount = Math.abs(safeAmount).toFixed(precision);
  const formattedValue =
    !currencySymbol || !showCurrency
      ? formattedAmount
      : currencySymbolPlacement === "suffix"
      ? `${formattedAmount}${currencySymbol}`
      : `${currencySymbol}${formattedAmount}`;

  return safeAmount < 0 ? `-${formattedValue}` : formattedValue;
};

export const useFormatAmount = () => {
  const {
    currencyPrecision,
    currencySymbol,
    currencySymbolPlacement,
    showCurrency
  } = useAppConfig();

  return (amount) =>
    formatCurrency(amount, {
      currencyPrecision,
      currencySymbol,
      currencySymbolPlacement,
      showCurrency,
    });
};
